import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "contents-question-expired-text" }
const _hoisted_3 = { class: "contents-question-button" }
const _hoisted_4 = { href: "#" }
const _hoisted_5 = {
  type: "button",
  id: "pagetop-button"
}

import Footer from "@/components/modules/base/Footer.vue";
const componentId = "generalpurpose03-02-d";

export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyExpired',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { id: componentId }, [
    _createElementVNode("div", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("header", null, [
        _createElementVNode("h1", { class: "header-icon" }, [
          _createElementVNode("a", { href: "#" }, [
            _createElementVNode("img", { src: "/server/necs/images/kanshin_logo.png" })
          ])
        ])
      ], -1)),
      _createElementVNode("main", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("survey_expired_msg")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", _hoisted_4, [
            _createElementVNode("button", _hoisted_5, _toDisplayString(_ctx.$t("survey_button_link_top")), 1)
          ])
        ])
      ]),
      _createVNode(Footer, { "scroll-target": componentId })
    ])
  ]))
}
}

})